export interface AttendanceWeekFilterState {
  companiesRecordId: string;
  orgUnitId: string;
  employeeId: string;
  weekDate: string;
  dateTo?: string;
  status?: string;
  employeeSearchText: string;
  currentPage: number;
  pageSize: number;
}

export function restoreAttendanceWeekFilterState(key: string): Partial<AttendanceWeekFilterState> {
  if (typeof sessionStorage === 'undefined') return {};

  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return {};
    const value = JSON.parse(raw) as Record<string, unknown>;
    const state: Partial<AttendanceWeekFilterState> = {};
    const stringFields = ['companiesRecordId', 'orgUnitId', 'employeeId', 'weekDate', 'dateTo', 'status', 'employeeSearchText'] as const;

    stringFields.forEach((field) => {
      if (typeof value[field] === 'string') state[field] = value[field] as string;
    });

    const currentPage = Number(value['currentPage']);
    const pageSize = Number(value['pageSize']);
    if (Number.isInteger(currentPage) && currentPage > 0) state.currentPage = currentPage;
    if (Number.isInteger(pageSize) && pageSize > 0) state.pageSize = pageSize;
    return state;
  } catch {
    sessionStorage.removeItem(key);
    return {};
  }
}

export function persistAttendanceWeekFilterState(key: string, state: AttendanceWeekFilterState): void {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(key, JSON.stringify(state));
}

export function clearAttendanceWeekFilterState(key: string): void {
  if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem(key);
}
